import { Box } from '@chakra-ui/react';
import React from 'react';
import { Chart } from './Chart';

export const CHART_HEIGHT = 110;

export const MoneyEarned: React.FC = () => {
  return (
    <Box
      flex={1}
      justifyContent="center"
      alignItems={'flex-end'}
      backgroundColor="gray.50"
      borderRadius="10px"
      h={'220px'}
      pb="24px">
      <Chart />
    </Box>
  );
};
